import getMatchedCountry from './get-matched-country';
/**
 * Check if countryCode is string and a valid country code
 * in locales array (checked against lib-locale in getMatchedCountry)
 * @param {string} countryCode e.g. "US"
 * @return {string|undefined} validated countryCode or undefined
 */
const getValidatedCountryCode = countryCode => {
  if (typeof countryCode === 'string' && getMatchedCountry(countryCode.toUpperCase())) {
    return countryCode.toUpperCase();
  }

  return undefined;
};

export default getValidatedCountryCode;
